import { render, staticRenderFns } from "./itinerary_air_4.vue?vue&type=template&id=1781ec44&"
import script from "./itinerary_air_4.vue?vue&type=script&lang=js&"
export * from "./itinerary_air_4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/deploy/beta-web-new/web_head/releases/20260601144942/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1781ec44')) {
      api.createRecord('1781ec44', component.options)
    } else {
      api.reload('1781ec44', component.options)
    }
    module.hot.accept("./itinerary_air_4.vue?vue&type=template&id=1781ec44&", function () {
      api.rerender('1781ec44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/app/desktop/itineraries/itinerary_air_4.vue"
export default component.exports